import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class SavedSearchService {

    private searchToSave = new Subject<any>
    private searchToDelete = new Subject<any>
    private searchToEdit = new Subject<any>
    private searchToLoad = new Subject<any>

    searchToSave$ = this.searchToSave.asObservable()
    searchToDelete$ = this.searchToDelete.asObservable()
    searchToEdit$ = this.searchToEdit.asObservable()
    searchToLoad$ = this.searchToLoad.asObservable()

    saveSearch(search : any) {
        this.searchToSave.next(search)
    }
    deleteSearch(search : any) {
        this.searchToDelete.next(search)
    }
    editSearch(search : any) {
        this.searchToEdit.next(search)
    }
    loadSearch(search : any) {
        this.searchToLoad.next(search)
    }
}
